module.exports = __webpack_public_path__ + "static/media/popup_menu.f50cfbc5.PNG";